<template>
    <v-card flat class="statistics-card">
        <v-row>
            <v-col cols="4">
                <div class="statistics-number">
                    {{ routinesMonthly }}
                </div>
                <div class="statistics-info">
                    {{ $t('student.routinesMonthly') }}
                </div>
            </v-col>
            <v-col cols="4" class="middle-border">
                <div class="statistics-number">
                    {{ routinesWeekly }}
                </div>
                <div class="statistics-info">
                    {{ $t('student.routinesWeekly') }}
                </div>
            </v-col>
            <v-col cols="4">
                <div class="statistics-number">
                    {{ averageTime }}
                </div>
                <div class="statistics-info">
                    {{ $t('student.averageTime') }}
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>

export default {
    name: "StudentStatistics",
    props: {
        docs: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            routinesWeekly: 0,
            routinesMonthly: 0,
            averageTime: 0,
        }
    },
    async mounted() {
        const vm = this
        await vm.loadStatistics()
    },
    methods: {
        async loadStatistics() {
            const vm = this
            vm.routinesMonthly = vm.docs.length || 0
            vm.averageTime = 0
            let hours = 0
            let datesRoutineInMonth = []
            vm.docs.forEach(doc => {
                datesRoutineInMonth.push(vm.$moment(doc.rawDate.full).format('DD-MM-YYYY'))
                hours += Number(doc.advance?.postInfo?.duration || 0)
            })
            hours = Number(hours / 60).toFixed(2).replace('.00', '')
            vm.averageTime = Number(hours / vm.routinesMonthly).toFixed(2).replace('NaN', '0').replace('.00', '')

            let startOfWeek = vm.$moment().startOf('week');
            let datesOfWeek = [startOfWeek.format('DD-MM-YYYY')]
            for (let i = 1; i <= 6; i++) datesOfWeek.push(startOfWeek.add(1, 'days').format('DD-MM-YYYY'))
            vm.routinesWeekly = datesOfWeek.filter(val => datesRoutineInMonth.includes(val)).length || 0
        }
    },
    watch: {
        docs() {
            this.loadStatistics()
        }
    }
}
</script>

<style scoped>

.statistics-card {
    border: 1px solid #F5F5F5;
    border-radius: 4px;
    padding: 12px;
}

.statistics-number {
    font-weight: 800;
    font-size: 26px;
    line-height: 32px;
    color: #078571;
}

.statistics-info {
    font-weight: 300;
    font-size: 13px;
    line-height: 16px;
    color: #333333;
}

.middle-border {
    border-left: 1px solid #CCFF99;
    border-right: 1px solid #CCFF99;
}

</style>